import {inject} from '@angular/core';
import {GlobalState} from '../../store/store.model';
import {Store} from '@ngrx/store';
import {CanActivateFn, CanDeactivateFn, Router} from '@angular/router';
import {map, take, tap, withLatestFrom} from 'rxjs';
import {authenticated} from '../../modules/authentication/store/authentication.selectors';
import {logout} from '../../modules/authentication/store/authentication.actions';

export const createAuthGuard = (redirectTo: string, shouldRedirect: (authorized: boolean) => boolean): CanActivateFn => () => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(authenticated).pipe(
    take(1),
    tap((authorized) => {
      if (shouldRedirect(authorized)) {
        router.navigate([redirectTo]);
      }
    })
  );
};

export const createLogoutGuard = (redirectTo: string): CanActivateFn => () => {
  const store = inject(Store<GlobalState>);
  const router = inject(Router);

  return store.select(authenticated).pipe(
    take(1),
    withLatestFrom(store.select(state => state.flow.guest)),
    map(([isAuthenticated, isGuest]) => {
      if (!isGuest) {
        store.dispatch(logout());
      }

      // Sempre redirect
      return router.createUrlTree([redirectTo]);
    })
  );
};


export const canExit = (redirectTo: string): CanDeactivateFn<any> => () => {
  const store = inject(Store);
  return store.select(authenticated).pipe(
    map((authenticated) => {
      return false;
    })
  )
};

export const authenticatedUser: CanActivateFn = createAuthGuard('/log-in', (authorized) => !authorized);
export const unauthenticatedUser: CanActivateFn = createAuthGuard('/tabs', (authorized) => authorized);

export const logoutRequest: CanActivateFn = createLogoutGuard('/get-started');
